/* Keep ingredient imagery local to the open disclosure. No product data writes. */
(() => {
  if (customElements.get('park-pdp-ingredients')) return;
  class ParkPDPIngredients extends HTMLElement {
    connectedCallback() {
      this.onToggle = event => {
        const detail = event.target;
        if (!detail.matches('details[data-ingredient]') || !detail.open) return;
        this.querySelectorAll('details[data-ingredient]').forEach(other => {
          if (other !== detail) other.open = false;
        });
        this.showImage(detail.dataset.ingredient);
      };
      this.addEventListener('toggle', this.onToggle, true);
      this.showImage(this.querySelector('details[data-ingredient][open]')?.dataset.ingredient);
    }
    disconnectedCallback() { this.removeEventListener('toggle', this.onToggle, true); }
    showImage(key) {
      const images = Array.from(this.querySelectorAll('[data-ingredient-image]'));
      const match = images.find(image => image.dataset.ingredientImage === key);
      const fallback = this.querySelector('[data-ingredient-default]');
      images.forEach(image => { image.hidden = image !== match; });
      if (fallback) fallback.hidden = Boolean(match);
      const media = this.querySelector('[data-ingredient-media]');
      if (media) media.hidden = !match && !fallback;
      this.classList.toggle('park-pdp-content--text-only', !match && !fallback);
    }
  }
  customElements.define('park-pdp-ingredients', ParkPDPIngredients);
})();
